import { APP_DEFAULT_LOCALE, APP_LOCALES } from '@/constants/i18n.constants'
import type { AppLocale } from '@/types/general'
import type { LocaleLink } from '@/types/i18n.types'

// Provides a fixed display order based on APP_LOCALES
export function sortLocaleLinksByAppLocales(localeLinks: LocaleLink[]): LocaleLink[] {
	return APP_LOCALES.reduce<LocaleLink[]>((acc, locale) => {
		const link = localeLinks.find((link) => link.locale === locale)
		if (link) acc.push(link)
		return acc
	}, [])
}

export function isDefaultLocale(locale: AppLocale, defaultLocale: AppLocale = APP_DEFAULT_LOCALE) {
	return locale === defaultLocale
}
